import { useParams, useRouteMatch } from 'react-router-dom'
import { RouteParams, routes } from '@sketch/modules-common'
import { useShowSingleFrame as useSetRendererSingleFrame } from '@sketch-hq/sketch-web-renderer'
import { useEffect } from 'react'
/**
 * Returns whether the current route is showing a single frame within a preview,
 * along with the frameUUID from the URL.
 *
 * Frame metadata (name, bounds) is available from `usePRFileArtboards()` once
 * the canvas is loaded — no extra GQL query needed.
 */
export function useShowSingleFrame() {
  const match = useRouteMatch({
    path: routes.PREVIEW_FRAME_VIEW.template(),
    exact: true,
  })

  const { frameUUID } = useParams<Partial<RouteParams<'PREVIEW_FRAME_VIEW'>>>()

  const [, setShowSingleFrame] = useSetRendererSingleFrame()

  useEffect(() => {
    setShowSingleFrame(frameUUID || null)
  }, [frameUUID, setShowSingleFrame])

  return {
    isShowingSingleFrame: !!match,
    frameUUID: match ? frameUUID : undefined,
  }
}
